import React from 'react';
import './Metro.css';
import FMSimage from '../Assets/Picture1water.jpg'; // First image (full size)
import FMSimage2 from '../Assets/metro3.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/metro4.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/metro2.jpeg'; // Image for Why Choose section
import FMSimage5 from '../Assets/metro5.jpg'; // Image for Industries section

const Metro = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">Water Quality & Quantity System</h1>
                    <p className="FMS-description">
                        The Water Quality & Quantity System from Vajra IoT is designed to monitor and manage both water quality and quantity in real-time, ensuring safety, efficiency, and compliance with environmental standards. Utilizing advanced sensors, cloud-based analytics, and automated reporting, this system tracks water parameters and usage, optimizing resource management for various applications.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Water Quality & Quantity System" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Water Quality & Quantity System provides continuous monitoring of critical water parameters such as pH, turbidity, dissolved oxygen, and flow rates. Real-time alerts for anomalies in quality or unexpected usage ensure prompt action. The system supports data logging and trend analysis for effective water resource management.
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Key Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        The system employs advanced sensors to collect real-time data on water quality (e.g., pH, turbidity) and quantity (e.g., flow rates, volume). Data is wirelessly transmitted to a central dashboard for analysis and visualization. Alerts for quality issues or abnormal usage enable rapid response. Historical data and predictive analytics optimize water treatment and usage efficiency.
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Water Quality & Quantity System</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Water Quality & Quantity System excels in precision, reliability, and user-friendliness, ensuring compliance and efficiency. Key benefits include:
                        <ul>
                            <li>Real-time monitoring of quality and quantity with instant alerts</li>
                            <li>Seamless integration with existing water management systems</li>
                            <li>Automated reporting for regulatory compliance</li>
                            <li>Advanced analytics for optimized water usage</li>
                            <li>Cloud-based storage and remote access</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our System */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our Water Quality & Quantity System</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using Water Quality & Quantity System" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Water Quality & Quantity System is trusted across multiple sectors for its robust monitoring and management capabilities. Key industries include:
                        <ul>
                            <li>Municipal Water Treatment</li>
                            <li>Industrial Water Processing</li>
                            <li>Agriculture & Irrigation</li>
                            <li>Environmental Monitoring</li>
                            <li>Commercial & Residential Water Systems</li>
                            <li>Food & Beverage Industry</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Metro;